import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
export const companyName="OVA2 Consultants Pvt. Ltd.";

